import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

/** Map route paths to readable page names for PostHog */
function getPageName(pathname: string): string {
  if (pathname === '/') return 'Home';
  if (pathname === '/about') return 'About';
  if (pathname === '/workwithus') return 'Contact';
  if (pathname === '/gallery') return 'Gallery';
  if (pathname.startsWith('/events/')) return 'Event Detail';
  if (pathname === '/adminlogin') return 'Admin Login';
  return pathname;
}

const PostHogPageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const pageName = getPageName(location.pathname);

    posthog.capture('$pageview', {
      $current_url: window.location.href,
      page_name: pageName,
      path: location.pathname,
    });
  }, [location]);

  return null;
};

export default PostHogPageTracker;
